export var TransportInfoStatus;
(function (TransportInfoStatus) {
    TransportInfoStatus["Accepted"] = "Accepted";
    TransportInfoStatus["Planned"] = "Planerad";
    TransportInfoStatus["Completed"] = "Completed";
    TransportInfoStatus["DriveTo"] = "Drive To";
})(TransportInfoStatus || (TransportInfoStatus = {}));
